<template>
	<div class="childDiv2" id="page12" ref="mainEl" page="6">
		<div class="childWrapper">
			<img alt="" src="images/1x_images/section2/page6/serum-how-to-use.png" srcset="images/2x_images/section2/page6/serum-how-to-use.png 2x" class="relative top-[210px] left-[90px]" />
			<div class="absolute center top-[320px]">
				<VideoComp :url="'videos/Video-How.mp4'" :poster="'videos/Poster-how.png'" ref="videoEl" />
			</div>
			<div class="flex absolute top-[940px] gap-[20px] w-fit center">
				<img class="button" alt="" src="images/1x_images/section2/page6/serum-how-to-use-step1.png" srcset="images/2x_images/section2/page6/serum-how-to-use-step1.png 2x" @click="jumpTo(1)" />
				<img class="button" alt="" src="images/1x_images/section2/page6/serum-how-to-use-step2.png" srcset="images/2x_images/section2/page6/serum-how-to-use-step2.png 2x" @click="jumpTo(2)" />
				<img class="button" alt="" src="images/1x_images/section2/page6/serum-how-to-use-step3.png" srcset="images/2x_images/section2/page6/serum-how-to-use-step3.png 2x" @click="jumpTo(3)" />
				<img class="button" alt="" src="images/1x_images/section2/page6/serum-how-to-use-step4.png" srcset="images/2x_images/section2/page6/serum-how-to-use-step4.png 2x" @click="jumpTo(4)" />
			</div>
			<img alt="" src="images/1x_images/section2/page6/btn-technique.png" srcset="images/2x_images/section2/page6/btn-technique.png 2x" class="button absolute center top-[1220px]" @click="showModal()" />
		</div>

		<!-- modal -->
		<div class="modal" ref="modalEl">
			<div class="childWrapper">
				<img alt="" class="button relative" src="images/1x_images/btn-close.png" srcset="images/2x_images/btn-close.png 2x" @click="closeModal()" />
				<div class="relative w-full">
					<div class="relative flex flex-col gap-[20px]">
						<img alt="" src="images/1x_images/section2/page6/text-application-technique.png" srcset="images/2x_images/section2/page6/text-application-technique.png 2x" class="relative center" />
						<div class="w-full relative center top-[-40px]">
							<div class="w-full relative top-[-25px]">
								<Carousel :images="techniqueImages" :top="-55" :spaceBetween="20" ref="carouselEl" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */
import VideoComp from "../../components/Videos.vue";
import Carousel from "../../components/Carousel.vue";
import gsap from "gsap";

export default {
	name: "page-1",
	components: { VideoComp, Carousel },
	data() {
		return {
			buttonProgress: [0, 0.113, 0.182, 0.381],
			techniqueImages: ["section2/page6/technique-img1.png", "section2/page6/technique-img2.png"],
		};
	},
	methods: {
		start() {
			this.$refs.videoEl.start();
		},
		stop() {
			this.$refs.videoEl.reset();
			this.$refs.carouselEl.reset();
		},
		jumpTo(val) {
			this.$refs.videoEl.jumpTo(this.buttonProgress[val - 1]);
		},
		showModal() {
			gsap.set("#main_nav", { autoAlpha: 0 });
			gsap.set(".page2-menu", { autoAlpha: 0 });
			this.$refs.videoEl.pauseVideo();
			gsap.set(this.$refs.modalEl, { autoAlpha: 1 });
		},
		closeModal() {
			gsap.set("#main_nav", { autoAlpha: 1 });
			gsap.set(".page2-menu", { autoAlpha: 1 });
			gsap.set(this.$refs.modalEl, { autoAlpha: 0 });
			this.$refs.carouselEl.reset();
		},
	},
	mounted() {},
};
</script>

<style scoped>
.modal .childWrapper {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
</style>
